const functions = {
    availableMethods() {
        return [
            'getOne',
            'getAll',
            'updateOne'
        ];
    }
};

export default functions;
